





































import { computed, defineComponent } from '@nuxtjs/composition-api';
import { SfProperty } from '@storefront-ui/vue';
import { storeToRefs } from 'pinia';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import useCart from '~/modules/checkout/composables/useCart';
import { useCartView } from '~/modules/checkout/composables/useCartView';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import { useCheckoutStore } from '~/stores/checkout';
import CouponCode from '../../../CouponCode.vue';
import Tooltip from '../../atoms/Tooltip/Tooltip.vue';
import SfProductCardHorizontal from '../Product/SfProductCardHorizontal.vue';

export default defineComponent({
  name: 'CartSummary',
  components: {
    SfProperty,
    CouponCode,
    SfProductCardHorizontal,
    Tooltip,
    SkeletonLoader,
  },
  props: {
    showProducts: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { cart } = useCart();
    const { totals, discount } = useCartView();
    const checkoutStore = useCheckoutStore();
    const { selectedShippingMethod, selectedPaymentMethod } = storeToRefs(checkoutStore);

    const products = computed(() => {
      const items = cartGetters.getItems(cart.value);
      return Array.isArray(items) ? items : [];
    });

    const shippingPrice = computed(() => selectedShippingMethod.value?.amount.value || 0);

    const orderDiscounts = computed(() => {
      let discounts = cartGetters.getDiscounts(cart.value)[0]?.name.split('(')[1].split(',') ?? [];
      discounts = discounts.map((discount) => discount.replace(')', '').trim());
      if (selectedPaymentMethod.value === 'jetpix') {
        discounts.push('3% OFF PARA PAGAMENTO COM PIX');
      }
      return Array.isArray(discounts) ? discounts : [];
    });

    return {
      totals,
      discount,
      products,
      shippingPrice,
      orderDiscounts,
    };
  },
});
